import apiClient from "../../api/client";

export const changePassword = (currentPassword, newPassword) =>
  apiClient.post("/admin/change-password", { currentPassword, newPassword });
